/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Tut_Save_IntroInputs */

const en_pc_tut_save_intro = /** @type {(inputs: Pc_Tut_Save_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saves are incremental and atomic, so a crash or power cut never corrupts your file.`)
};

const zh_pc_tut_save_intro = /** @type {(inputs: Pc_Tut_Save_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`保存是增量且原子化的，崩溃或断电都不会损坏文件。`)
};

/**
* | output |
* | --- |
* | "Saves are incremental and atomic, so a crash or power cut never corrupts your file." |
*
* @param {Pc_Tut_Save_IntroInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_tut_save_intro = /** @type {((inputs?: Pc_Tut_Save_IntroInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Tut_Save_IntroInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_tut_save_intro(inputs)
	return zh_pc_tut_save_intro(inputs)
});
export { pc_tut_save_intro as "pc.tut.save.intro" }